// extracted by mini-css-extract-plugin
export default {"subsection":"PresentationConfigs__subsection-GNHQJ","attrsTableCol":"PresentationConfigs__attrsTableCol-fKPQ3"};